import React, { useState } from 'react';
import styled from 'styled-components';
import WizrButton from '../WizrButton';

interface CustomStatusFilterProps {
  selectedKeys: string[];
  setSelectedKeys: (keys: string[]) => void;
  confirm: () => void;
  clearFilters: () => void;
  visible: boolean;
  onFilterCountChange?: (count: number) => void;
}

const CustomStatusFilter: React.FC<CustomStatusFilterProps> = ({
  selectedKeys,
  setSelectedKeys,
  confirm,
  clearFilters,
  visible,
  onFilterCountChange,
}) => {
  const [localSelectedKeys, setLocalSelectedKeys] = useState<string[]>(selectedKeys);

  const handleCheckboxChange = (value: string) => {
    const newKeys = localSelectedKeys.includes(value)
      ? localSelectedKeys.filter(k => k !== value)
      : [...localSelectedKeys, value];
    setLocalSelectedKeys(newKeys);
  };

  const handleApply = () => {
    setSelectedKeys(localSelectedKeys);
    onFilterCountChange?.(localSelectedKeys.length);
    confirm();
  };

  const handleClear = () => {
    setLocalSelectedKeys([]);
    setSelectedKeys([]);
    onFilterCountChange?.(0);
    clearFilters();
  };

  if (!visible) return null;

  return (
    <FilterDropdown>
      <FilterContent>
        <FilterOption>
          <StyledCheckbox
            type="checkbox"
            checked={localSelectedKeys.includes('active')}
            onChange={() => handleCheckboxChange('active')}
          />
          <FilterLabel>Active</FilterLabel>
        </FilterOption>
        
        <FilterOption>
          <StyledCheckbox
            type="checkbox"
            checked={localSelectedKeys.includes('created')}
            onChange={() => handleCheckboxChange('created')}
          />
          <FilterLabel>Created</FilterLabel>
        </FilterOption>
        
        <FilterOption>
          <StyledCheckbox
            type="checkbox"
            checked={localSelectedKeys.includes('inactive')}
            onChange={() => handleCheckboxChange('inactive')}
          />
          <FilterLabel>Inactive</FilterLabel>
        </FilterOption>
        
        <FilterOption>
          <StyledCheckbox
            type="checkbox"
            checked={localSelectedKeys.includes('inviteSend')}
            onChange={() => handleCheckboxChange('inviteSend')}
          />
          <FilterLabel>Invite Send</FilterLabel>
        </FilterOption>
      </FilterContent>
      
      <ButtonContainer>
        <ClearButton onClick={handleClear}>
          Clear
        </ClearButton>
        <ApplyButton onClick={handleApply}>
          Apply
        </ApplyButton>
      </ButtonContainer>
    </FilterDropdown>
  );
};

const FilterDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: 180px;
  padding: 12px;
`;

const FilterContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FilterOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledCheckbox = styled.input`
  width: 16px;
  height: 16px;
  accent-color: #1D1F22;
  cursor: pointer;
`;

const FilterLabel = styled.span`
  color: #1A1A1A;
  font-size: 14px;
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 12px;
  gap: 8px;
`;

const ClearButton = styled.button`
  border: 1px solid #E5E7EB;
  border-radius: 20px;
  padding: 4px 16px;
  color: #1A1A1A;
  background: white;
  cursor: pointer;
  font-size: 14px;
  
  &:hover {
    background: #f9f9f9;
  }
`;

const ApplyButton = styled.button`
  border-radius: 20px;
  padding: 4px 16px;
  background: #1A1A1A;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 14px;
  
  &:hover {
    background: #333;
  }
`;

export default CustomStatusFilter;
